export enum ExternalService {
  airtable = 'airtable',
  calendso = 'calendso',
  elaraRealtime = 'elara-realtime',
  ordoclic = 'ordoclic',
  rocketchat = 'rocketchat',
  reports = 'reports',
  medicalActs = 'medical-acts',
  medicalActsAdmin = 'medical-acts-admin',
}

export type ExternalServiceType = `${ExternalService}`

export const externalServices: ExternalServiceType[] = ['ordoclic', 'reports', 'medical-acts', 'elara-realtime', 'airtable']
